import { Routes } from '@angular/router';
import { SecurityComponent } from './pages/security/security.component';
import usersRoutes from './pages/users/users.routes';
import companiesRoutes from './pages/companies/companies.routes';
import designRoutes from './pages/design/design.routes';
import { RoleGuard } from '../core/guards/auth.guard';
import { Permission } from '../core/models/role-permissions.models';

export default [
	{
		path: 'users',
		loadChildren: () => usersRoutes,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.USER_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'companies',
		loadChildren: () => companiesRoutes,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.COMPANY_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'security',
		loadComponent: () => SecurityComponent,
	},
	{
		path: 'design',
		loadChildren: () => designRoutes,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.DESIGN_CONFIG_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'apikeys',
		redirectTo: '/developers',
		pathMatch: 'full',
	},
	{
		path: 'legal-terms',
		loadChildren: () => import('./pages/legal-terms/legal-terms.routes').then((m) => m.default),
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.POLICY_CHECK_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'client-alerts',
		loadChildren: () => import('./pages/client-alerts/client-alerts.routes').then((m) => m.default),
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.CLIENT_ALERT_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'error-catalog',
		loadChildren: () => import('./pages/error-catalog/error-catalog.routes').then((m) => m.default),
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.ERRORS_NUMBER_VIEW],
			comeback: 'panel',
		},
	},
] as Routes;
